import React, {useState, useEffect} from 'react';
import {connect, useDispatch} from 'react-redux';
import PropTypes from 'prop-types';
import {makeStyles} from 'tss-react/mui';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import Grid from '@mui/material/Grid';
import Container from '@mui/material/Container';
import Typography from '@mui/material/Typography';
import {DatePicker} from '@mui/x-date-pickers';
//DS
import {openMsg, loadingModal} from 'src/redux-app';
import {showSucces} from 'src/common/toast';
import {GroupBox, SelectDs, hooks} from 'lib.front';
import {esquemaCampos, esquemaValidacion} from './esquemas';
import {queryData, queryCodActivacion, mutationGenerarLicencia, queryDataVer} from './queries';
import {cmps} from './constantes';
const {useValidacion, useApolloQ, useApolloLazyQ, useApolloMutation} = hooks;

const useStyles = makeStyles()(theme => ({
   container: {
      marginTop: theme.spacing(2)
   },
   tabla: {
      width: '100%'
   }
}));

const tiposDocumento = ['01', '03'];

function genValue(reg) {
   return reg.codigo;
}
function genLabel(reg) {
   return reg.denominacion;
}
function genId(reg) {
   return reg.codigo;
}

function ModificarLicencia(props) {
   const dispatch = useDispatch();
   const {classes, cx} = useStyles();
   //SEPARA PROPIEDADES
   const {onSuccessCallback, onCloseCallback, codigoActivacion, usuario} = props;
   //Informacion de usuario
   //Modal de espera
   function openWaitModal(load) {
      dispatch(loadingModal(load));
   }
   //Modal para mensajes
   function openMsgModal(msg) {
      dispatch(openMsg(msg));
   }
   //Estados de control
   const [disabled, setDisabled] = useState(false);
   //Estados
   const [grupo, setGrupo] = useState(-1);
   const {
      campos,
      existeError,
      handleOnChange,
      validacionManual,
      setCampo,
      inicializar,
      validarTodos
   } = useValidacion(esquemaCampos, esquemaValidacion);

   function onBlurValidacion(e) {
      validacionManual(e.target.name, e.target.value);
   }

   //Data Generica
   const [productos, setProductos] = useState([]);
   const [versiones, setVersiones] = useState([]);
   const [presentaciones, setPresentaciones] = useState([]);
   const [modulares, setModulares] = useState([]);
   const [disable, setDisable] = useState(true);
   function procesarDataGenerica(data) {
      if (data['productos'] && data['productos'].length > 0) {
         setProductos(data['productos']);
         setCampo('producto', data['productos'][0].codigo);
      }
      if (data['versiones'] && data['versiones'].length > 0) {
         setVersiones(data['versiones']);
         setCampo('version', data['versiones'][0].codigo);
      }
      if (data['presentaciones'] && data['presentaciones'].length > 0) {
         setPresentaciones(data['presentaciones']);
         setCampo('presentacion', data['presentaciones'][0].codigo);
      }
      if (data['modulares'] && data['modulares'].length > 0) {
         setModulares(data['modulares']);
         setCampo('modular', data['modulares'][0].codigo);
      }
   }
   useApolloQ(queryData, {
      callbackProcesarData: procesarDataGenerica,
      callbackError: openMsgModal,
      callbackLoading: openWaitModal
   });

   //DATA CODIGO ACTIVACION
   function procesarDataCodActivacion(data) {
      if (data.codigoActivacion && data.codigoActivacion.length > 0) {
         const dataCod = data.codigoActivacion[0];
         setCampo('ruc', dataCod.ruc);
         setCampo('razonSocial', dataCod.razonSocial);
         setCampo('producto', dataCod.producto);
         setCampo('presentacion', dataCod.presentacion);
         setCampo('version', dataCod.version);
         setCampo('modular', dataCod.modular ? dataCod.modular : '');
         setCampo('anio', dataCod.anio);
         setCampo('tipoDoc', dataCod.tipoDoc);
         setCampo('serieDoc', dataCod.serieDoc);
         setCampo('nroDoc', dataCod.nroDoc);
         if (dataCod.fechaExpiracion) {
            setCampo('fechaExpiracion', new Date(dataCod.fechaExpiracion.replace(/-/g, '/')));
         }
         if (dataCod.fechaVigenciaApi) {
            setCampo('fechaVigenciaApi', new Date(dataCod.fechaVigenciaApi.replace(/-/g, '/')));
         }
         if (dataCod.fechaVigenciaSoporte) {
            setCampo('fechaVigenciaSoporte', new Date(dataCod.fechaVigenciaSoporte.replace(/-/g, '/')));
         }
         //agregar fecha de vigencia para apis
         setGrupo(dataCod.grupo);
         setDisabled(true);
      }
   }

   const [getCodigoActivacion] = useApolloLazyQ(queryCodActivacion, {
      callbackProcesarData: procesarDataCodActivacion,
      callbackError: openMsgModal,
      callbackLoading: openWaitModal
   });

   function recuperarCodActivacion() {
      if (campos.codActivacion.valor) {
         getCodigoActivacion({
            variables: {
               codigo: campos.codActivacion.valor
            }
         });
      }
   }

   /********* */
   function procesarDataGenericaVersion(data) {
      if (data.productoDetallesFiltro && data.productoDetallesFiltro.length > 0) {
         const objetoVersiones = data.productoDetallesFiltro.reduce(
            (Acumulador, valorActual, Indice) => {
               Acumulador[valorActual.version.codigo] = valorActual.version;
               return Acumulador;
            },
            {}
         );
         const arrayVersiones = Object.values(objetoVersiones);
         if (!arrayVersiones.some(ver => ver.codigo == campos.version.valor)) setCampo('version', arrayVersiones[0].codigo);
         setVersiones(Object.values(arrayVersiones));
      }
   }
   function procesarDataGenericaPresentacion() {
      if (DatosFiltro && DatosFiltro.productoDetallesFiltro.length > 0) {
         setDisable(false);
         let arrayPresentacion = [];
         DatosFiltro.productoDetallesFiltro.forEach(element => {
            if (element.version.codigo === campos.version.valor) {
               arrayPresentacion.push(element.presentacion);
            }
         });
         if (arrayPresentacion.length != 0) {
            if (!arrayPresentacion.some(pres => pres.codigo == campos.presentacion.valor)) setCampo('presentacion', arrayPresentacion[0].codigo);
            setPresentaciones(arrayPresentacion);
         }
      }
   }
   const [getVersion, {data: DatosFiltro}] = useApolloLazyQ(queryDataVer, {
      callbackProcesarData: procesarDataGenericaVersion,
      callbackError: openMsgModal,
      callbackLoading: openWaitModal
   });
   useEffect(() => {
      if (campos.producto.valor) {
         const variables = {
            codigoProducto: campos.producto.valor
         };
         getVersion({variables: variables});
      }
   }, [campos.producto.valor]);
   useEffect(() => {
      if (Boolean(campos.version.valor)) {
         procesarDataGenericaPresentacion();
      }
   }, [campos.version.valor, DatosFiltro]);
   /********* */

   useEffect(() => {
      if (codigoActivacion) {
         setCampo('codActivacion', codigoActivacion);
         getCodigoActivacion({
            variables: {
               codigo: codigoActivacion
            }
         });
      }
   }, [codigoActivacion]);
   //Grabar las licencias generadas
   const [grabarLicencias] = useApolloMutation(mutationGenerarLicencia, {
      callbackProcesarData: procesarGenerarLicenciaData,
      callbackError: openMsgModal,
      callbackLoading: openWaitModal
   });
   async function generarParametros() {
      let parametrosSpu = {
         ruc: campos.ruc.valor,
         razonsocial: campos.razonSocial.valor,
         tipoDoc: campos.tipoDoc.valor,
         serieDoc: campos.serieDoc.valor,
         nroDoc: campos.nroDoc.valor,
         usuario: usuario.usuario
      };
      const activacionesDatos = [
         {
            codigo: campos.codActivacion.valor,
            grupo,
            anio: campos.anio.valor,
            producto: campos.producto.valor,
            version: campos.version.valor,
            presentacion: campos.presentacion.valor,
            modular: campos.modular.valor === '' ? null : campos.modular.valor,
            fechaExpiracion: campos.fechaExpiracion.valor
               ? `${campos.fechaExpiracion.valor.getFullYear()}-${campos.fechaExpiracion.valor.getMonth() +
                    1}-${campos.fechaExpiracion.valor.getDate()}`
               : null,
            fechaVigenciaApi: campos.fechaVigenciaApi.valor
               ? `${campos.fechaVigenciaApi.valor.getFullYear()}-${campos.fechaVigenciaApi.valor.getMonth() +
                    1}-${campos.fechaVigenciaApi.valor.getDate()}`
               : null,
            fechaVigenciaSoporte: campos.fechaVigenciaSoporte.valor
               ? `${campos.fechaVigenciaSoporte.valor.getFullYear()}-${campos.fechaVigenciaSoporte.valor.getMonth() +
                    1}-${campos.fechaVigenciaSoporte.valor.getDate()}`
               : null
            //agregar fecha de vigencia para apis
         }
      ];
      parametrosSpu.activaciones = activacionesDatos;
      return parametrosSpu;
   }

   async function procesarGrabar() {
      const esOkGrabar = await validarTodos();
      if (esOkGrabar) {
         const variables = await generarParametros();
         grabarLicencias({variables});
      }
   }
   async function procesarGenerarLicenciaData(data) {
      if (data['generarLicencia'] && data['generarLicencia'].msg !== '') {
         showSucces(data['generarLicencia'].msg);
         inicializarForm();
         onSuccessCallback();
      }
   }
   //===== FUNCIONES =====
   function inicializarForm() {
      setDisabled(false);
      setGrupo(-1);
      inicializar();
      onCloseCallback();
   }
   return (
      <Container className={cx('containerbox', classes.container)} maxWidth="md">
         <Grid container spacing={1}>
            <Grid item xs={12}>
               <Typography variant="h4" gutterBottom align="center">
                  Modificar Licencia
               </Typography>
            </Grid>
            <Grid container item xs={12} spacing={1} alignItems="center">
               <Grid item xs={8}>
                  <TextField
                     label="Código de Activación"
                     name={cmps.COD_ACTIVACION}
                     variant="outlined"
                     margin="dense"
                     fullWidth
                     required
                     onChange={handleOnChange}
                     onBlur={onBlurValidacion}
                     value={campos.codActivacion.valor}
                     error={campos.codActivacion.error !== ''}
                     helperText={campos.codActivacion.error}
                     disabled={disabled}
                  />
               </Grid>
               <Grid item xs={4}>
                  <Button onClick={recuperarCodActivacion} variant="contained" disabled={disabled}>
                     Recuperar
                  </Button>
               </Grid>
            </Grid>
            <Grid container item xs={12}>
               <GroupBox label="Datos Empresa" fullWidth style={{borderRadius:'8px'}}>
                  <Grid container spacing={1}>
                     <Grid item xs={5}>
                        <TextField
                           label="RUC"
                           name={cmps.RUC}
                           variant="outlined"
                           margin="dense"
                           fullWidth
                           required
                           value={campos.ruc.valor}
                           disabled
                        />
                     </Grid>
                     <Grid item xs={7}>
                        <TextField
                           label="Razon Social"
                           name={cmps.RAZON_SOCIAL}
                           variant="outlined"
                           margin="dense"
                           fullWidth
                           required
                           value={campos.razonSocial.valor}
                           disabled
                        />
                     </Grid>
                  </Grid>
               </GroupBox>
            </Grid>
            <Grid container item xs={12}>
               <GroupBox label="Migrar Licencia">
                  <Grid style={{paddingTop: '15px'}} container spacing={1} alignItems="center">
                     <Grid item xs={4}>
                        <GroupBox label="Documento">
                           <Grid container spacing={1}>
                              <Grid item xs={4}>
                                 <SelectDs
                                    id="selectTipoDoc"
                                    name={cmps.TIPO_DOC}
                                    label="Tipo"
                                    variant="outlined"
                                    value={campos.tipoDoc.valor}
                                    onChange={handleOnChange}
                                    margin="dense"
                                    data={tiposDocumento}
                                    error={campos.tipoDoc.error !== ''}
                                    helperText={campos.tipoDoc.error}
                                    required
                                    fullWidth
                                    disabled={!disabled}
                                 />
                              </Grid>
                              <Grid item xs={4}>
                                 <TextField
                                    label="Serie"
                                    name={cmps.SERIE_DOC}
                                    variant="outlined"
                                    margin="dense"
                                    fullWidth
                                    required
                                    onChange={handleOnChange}
                                    onBlur={onBlurValidacion}
                                    value={campos.serieDoc.valor}
                                    error={campos.serieDoc.error !== ''}
                                    helperText={campos.serieDoc.error}
                                    disabled={!disabled}
                                 />
                              </Grid>
                              <Grid item xs={4}>
                                 <TextField
                                    label="Número"
                                    name={cmps.NRO_DOC}
                                    variant="outlined"
                                    margin="dense"
                                    fullWidth
                                    required
                                    onChange={handleOnChange}
                                    onBlur={onBlurValidacion}
                                    value={campos.nroDoc.valor}
                                    error={campos.nroDoc.error !== ''}
                                    helperText={campos.nroDoc.error}
                                    disabled={!disabled}
                                 />
                              </Grid>
                           </Grid>
                        </GroupBox>
                     </Grid>
                     <Grid item xs={8}>
                        <GroupBox label="Licencia">
                           <Grid container spacing={1}>
                              <Grid item xs={2}>
                                 <TextField
                                    label="Año"
                                    name={cmps.ANIO}
                                    variant="outlined"
                                    margin="dense"
                                    type="number"
                                    fullWidth
                                    required
                                    onChange={handleOnChange}
                                    onBlur={onBlurValidacion}
                                    value={campos.anio.valor}
                                    error={campos.anio.error !== ''}
                                    helperText={campos.anio.error}
                                    InputLabelProps={{
                                       shrink: true
                                    }}
                                    disabled={!disabled}
                                 />
                              </Grid>
                              <Grid container spacing={1} item xs={10} style={{paddingTop:'16px'}}>
                                 <Grid item xs={4}>
                                    <DatePicker
                                       name={cmps.FECHA_EXPIRACION}
                                       margin="dense"
                                       label="Fecha Expiración"
                                       format="dd/MM/yyyy"
                                       value={campos.fechaExpiracion.valor}
                                       onChange={date => {
                                          validacionManual(cmps.FECHA_EXPIRACION, date);
                                          if (date > campos.fechaVigenciaApi.valor) {
                                             validacionManual(cmps.FECHA_VIGENCIA_API, date);
                                             validacionManual(cmps.FECHA_VIGENCIA_SOPORTE, date);
                                          }
                                       }}
                                       inputVariant="outlined"
                                       KeyboardButtonProps={{
                                          'aria-label': 'elegir fecha'
                                       }}
                                       minDate={new Date()}
                                       fullWidth
                                       disabled={!disabled}
                                    />
                                 </Grid>
                                 <Grid item xs={4}>
                                    <DatePicker
                                       name={cmps.FECHA_VIGENCIA_API}
                                       margin="dense"
                                       label="Fecha Fin APIs"
                                       format="dd/MM/yyyy"
                                       value={campos.fechaVigenciaApi.valor}
                                       onChange={date => {
                                          validacionManual(cmps.FECHA_VIGENCIA_API, date);
                                       }}
                                       inputVariant="outlined"
                                       KeyboardButtonProps={{
                                          'aria-label': 'elegir fecha'
                                       }}
                                       minDate={new Date()}
                                       fullWidth
                                       disabled={!disabled}
                                    />
                                 </Grid>
                                 <Grid item xs={4}>
                                    <DatePicker
                                       name={cmps.FECHA_VIGENCIA_SOPORTE}
                                       margin="dense"
                                       label="Fecha Fin Soporte"
                                       format="dd/MM/yyyy"
                                       value={campos.fechaVigenciaSoporte.valor}
                                       onChange={date => {
                                          validacionManual(cmps.FECHA_VIGENCIA_SOPORTE, date);
                                       }}
                                       inputVariant="outlined"
                                       KeyboardButtonProps={{
                                          'aria-label': 'elegir fecha'
                                       }}
                                       minDate={new Date()}
                                       fullWidth
                                       disabled={!disabled}
                                       slotProps={{textField:{required: true}}}
                                    />
                                 </Grid>
                              </Grid>
                           </Grid>
                        </GroupBox>
                     </Grid>
                     <Grid item xs={12}>
                        <GroupBox label="Producto">
                           <Grid container spacing={1}>
                              <Grid item xs={4}>
                                 <SelectDs
                                    id="selectProducto"
                                    name={cmps.PRODUCTO}
                                    label="Producto"
                                    variant="outlined"
                                    value={campos.producto.valor}
                                    onChange={handleOnChange}
                                    margin="dense"
                                    data={productos}
                                    error={campos.producto.error !== ''}
                                    helperText={campos.producto.error}
                                    genItemValue={genValue}
                                    genItemKey={genId}
                                    genItemLabel={genLabel}
                                    required
                                    fullWidth
                                    disabled={!disabled}
                                 />
                              </Grid>
                              <Grid item xs={4}>
                                 <SelectDs
                                    id="selectVersion"
                                    name={cmps.VERSION}
                                    label="Version"
                                    variant="outlined"
                                    value={campos.version.valor}
                                    onChange={handleOnChange}
                                    margin="dense"
                                    data={versiones}
                                    error={campos.version.error !== ''}
                                    helperText={campos.version.error}
                                    genItemValue={genValue}
                                    genItemKey={genId}
                                    genItemLabel={genLabel}
                                    required
                                    fullWidth
                                    disabled={!disabled}
                                 />
                              </Grid>
                              <Grid item xs={4}>
                                 <SelectDs
                                    id="selectPresentacion"
                                    name={cmps.PRESENTACION}
                                    label="Presentacion"
                                    variant="outlined"
                                    value={campos.presentacion.valor}
                                    onChange={handleOnChange}
                                    margin="dense"
                                    data={presentaciones}
                                    error={campos.presentacion.error !== ''}
                                    helperText={campos.presentacion.error}
                                    genItemValue={genValue}
                                    genItemKey={genId}
                                    genItemLabel={genLabel}
                                    required
                                    fullWidth
                                    disabled={!disabled}
                                 />
                              </Grid>
                              {/** 
                              <Grid item xs={3}>
                                 <SelectDs
                                    id="selectModular"
                                    name={cmps.MODULAR}
                                    label="Modular"
                                    variant="outlined"
                                    value={campos.modular.valor}
                                    onChange={handleOnChange}
                                    margin="dense"
                                    data={modulares}
                                    error={campos.modular.error !== ''}
                                    helperText={campos.modular.error}
                                    genItemValue={genValue}
                                    genItemKey={genId}
                                    genItemLabel={genLabel}
                                    required
                                    fullWidth
                                    disabled={!disabled}
                                 />
                              </Grid>
                              */}
                           </Grid>
                        </GroupBox>
                     </Grid>
                  </Grid>
               </GroupBox>
            </Grid>
            <Grid container item xs={12} justifyContent="space-between">
               <Grid item xs={3}>
                  <Button
                     onClick={procesarGrabar}
                     variant="contained"
                     disabled={existeError}
                     fullWidth
                  >
                     Guardar
                  </Button>
               </Grid>
               <Grid item xs={3}>
                  <Button onClick={inicializarForm} variant="contained" fullWidth>
                     Cancelar
                  </Button>
               </Grid>
            </Grid>
         </Grid>
      </Container>
   );
}

ModificarLicencia.propTypes = {
   onSuccessCallback: PropTypes.func,
   onCloseCallback: PropTypes.func,
   codigoActivacion: PropTypes.string
};
ModificarLicencia.defaultProps = {
   onSuccessCallback: Data => {
      return;
   },
   onCloseCallback: () => {
      return;
   }
};

function mapStateToProps(state) {
   return {
      usuario: state.auth.usuario
   };
}
function mapDispatchToProps() {
   return {};
}

export default connect(mapStateToProps, mapDispatchToProps)(ModificarLicencia);
